import { Component } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-main-report',
  templateUrl: './main-report.component.html',
  styleUrls: ['./main-report.component.scss']
})
export class MainReportComponent {
  selectedDate: Date;
  selectedStartDate: Date;
  selectedEndDate: Date;
  certSelectedStartDate: Date;
  certSelectedEndDate: Date;
  constructor() { }

  onChange($event: MatDatepickerInputEvent<Date>) {
    this.selectedDate = $event.value;
  }
  onStartDateChange($event: MatDatepickerInputEvent<Date>) {
    this.selectedStartDate = $event.value;
  }
  onEndDateChange($event: MatDatepickerInputEvent<Date>) {
    this.selectedEndDate = $event.value;
  }
  onCertStartDateChange($event: MatDatepickerInputEvent<Date>) {
    this.certSelectedStartDate = $event.value;
  }
  onCertEndDateChange($event: MatDatepickerInputEvent<Date>) {
    this.certSelectedEndDate = $event.value;
  }
}
